import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LeftNavModel } from '../navigation';

@Component({
    selector: 'fold-menu',
    templateUrl: './fold-menu.component.html',
    styleUrls: ['./fold-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FoldMenuComponent {
    @Input() leftNav!: LeftNavModel[];
    @Input() goToUrl: any;
    @Input() logout!: Function;
}
